<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Executors</h3>

      <!-- Do you want to change any executors? -->
      <ExecutorsYN v-model="form.executorsYN"/>
      <Executors v-if="form.executorsYN" v-model="form.executors"/>
    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import ExecutorsYN from "@/components/common/questionnaires/question/questions/amendment/ExecutorsYN.vue";
import Executors from "@/components/common/questionnaires/question/questions/amendment/Executors.vue";

export default {
  name: 'ExecutorsAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    ExecutorsYN,
    Executors,
  },
  data() {
    return {
      label: 'Executors', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
